import { RESOURCE_TYPE, RESOURCE_DOMAIN } from "@plugins/common/constant/resource.constant.ts";
import { MEDIA_TYPE } from "@plugins/media/media.constant";

export default {
  computed: {
    /**
     * This computed property returns the location UI display based on resource domain
     */
    location() {
      return (location) => {
        switch (location) {
          case "PERSONAL":
            return this.$i18n.t("my_drive_label");
          case "MOE":
            return this.$i18n.t("moe_library_label");
          case "COMMUNITY":
          case "Community":
            return this.$i18n.t("community_gallery_label");
          case "ALP_TEMPLATE": {
            return this.$i18n.t("alp_template_label");
          }
          case "APP":
            return this.$i18n.t("app_library_label");
          case "ASSIGNMENT":
            return this.$i18n.t("class_group_label");
          default:
            return "";
        }
      };
    },
    /**
     * This computed property returns the icon type based on resource type
     * For LESSON resource type, it will show if it is shared or not
     * For MEDIA resource type, it will be further specified based on its file type (Refer to MEDIA_ARRAY)
     */
    iconType() {
      return (resourceType, fileType, shared) => {
        if (resourceType !== RESOURCE_TYPE.MEDIA) {
          switch (resourceType) {
            case RESOURCE_TYPE.FOLDER:
              return "Folder32";
            case RESOURCE_TYPE.LESSON:
              return shared ? "LessonStudentSharing32" : "Lesson32";
            case RESOURCE_TYPE.QUESTION:
              return "Question32";
            case RESOURCE_TYPE.QUIZ:
              return "Quiz32";
            case RESOURCE_TYPE.APP:
              return "App32";
            case RESOURCE_TYPE.RUBRIC:
              return "Rubrics32";
            default:
              return "";
          }
        }
        switch (fileType) {
          case MEDIA_TYPE.VIDEO:
            return "Video32";
          case MEDIA_TYPE.AUDIO:
            return "Audio32";
          case MEDIA_TYPE.IMAGE:
            return "Image32";
          case MEDIA_TYPE.PDF:
            return "PDF32";
          case MEDIA_TYPE.POWERPOINT:
            return "Powerpoint32";
          case MEDIA_TYPE.EXCEL:
            return "Excel32";
          case MEDIA_TYPE.WORD:
            return "Word32";
          case MEDIA_TYPE.HTML5:
            return "Interactive32";
          case MEDIA_TYPE.ZIP:
          case MEDIA_TYPE.OTHERS:
            return "Folder32";
          default:
            return "";
        }
      };
    },
    checkIfMoe() {
      return this.resourceData.resourceDomain === RESOURCE_DOMAIN.MOE;
    },
    checkIfCommunity() {
      return this.resourceData.resourceDomain === RESOURCE_DOMAIN.COMMUNITY;
    },
  },
};
